import { initMetadataForInterface1egvbzx539z91 as initMetadataForInterface } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var UploadClass;
function Upload() {
  if (UploadClass === VOID) {
    class $ {}
    initMetadataForInterface($, 'Upload');
    UploadClass = $;
  }
  return UploadClass;
}
//region block: exports
export {
  Upload as Upload1b180qcf3cx10,
};
//endregion

//# sourceMappingURL=Upload.mjs.map
